import { type Environment, getEnvironmentConfig as getSharedConfig } from '@mapp-byte-connect/config';

const buildEnv = import.meta.env.VITE_BUILD_ENV || 'local';

export const environmentConfig = getSharedConfig(buildEnv);
export const currentEnvironment = buildEnv as Environment;
